import React, { useEffect, useState } from 'react';
import "./CircledOption.scss";
import useDimensions from "../../../hooks/useDimensions"

const CircledOption = (props) => {

    /** Props */
    const { 
        data, 
        text, 
        dots=false, 
        onClickHandle, 
        currentIndex,
        itemSelected,
        answerCallback,
        className="left" ,
        disabled
    } = props

    /** States */
    const [ currentDecision, setCurrentDecision ] = useState();
    const [ isSelected, setIsSelected ] = useState();
    const [ showChild, setShowChild ] = useState();
    const [ decisionIndex, setDecisionIndex ] = useState();

    /** Dimensions References */
    const [viewPortRef, viewPort] = useDimensions(true)

    /** Calculate Positions */
    function calcPos(e, params ){

        const {meridian, propX, propY} = params

        const point = e.currentTarget.getBoundingClientRect();

        const offsetX = point.left - (viewPort.x);
        const offsetY = point.top - (viewPort.y);
        const x = (offsetX > meridian ? ( offsetX - 310): ( offsetX + point.width)) - propX;
        const y = offsetY + propY;

        return  { x, y }
    }

    useEffect(()=>{
        
        if(!itemSelected){
            setShowChild(false)
            setDecisionIndex()
        }

        setIsSelected(itemSelected)

    },[itemSelected])

    useEffect(() => {
        
        setCurrentDecision({
            ...data,
            decisions: 
                (data.answers > 0 ? 
                    data.answers : 
                    data.decisions 
                ) 
        })
    },[data])


    const handleSelection = (e, index) => {
        e.stopPropagation()

        if(disabled) return false

        if(!isSelected){

            setIsSelected(true)

            const pos = calcPos(e, {
                "meridian": 500,
                "propX": 5,
                "propY": -10,
            });
            
            setCurrentDecision({
                ...currentDecision,
                choosed:true
            })
            setShowChild(pos)         
            if(onClickHandle) onClickHandle(index)
        }
        else{
            setIsSelected(false)

            setCurrentDecision({
                ...currentDecision,
                choosed:false
            })
            setShowChild()

            if(onClickHandle) onClickHandle()

        }
        
    }

    const handleChildSelection = (e, index, parentIndex, isDecision) => {

        setDecisionIndex(index)
        if(!isDecision) answerCallback(
            parentIndex, 
            currentDecision.decisions[index]
        )

    }

    const hasDecisions = (current) =>{
        return (current.decisions && current.decisions.length > 0)
    }

    const Dots = ({choosed}) => {
        return (
            <div className={`dot ${choosed ? 'choosed' : ''}`}   /> 
        )
    }

    return (
        <div className={`circled-option ${className}`} 
                onClick={(e) => handleSelection(e, currentIndex)}
                ref={viewPortRef} >
                
                <div className="text">
                    {text}
                </div>
                
                <div className={`circle ${className}`}>
                    {dots && currentDecision?.decisions && currentDecision.decisions.map((item, index) => ( 
                        <Dots key={index} data={item} choosed={item.choosed} />
                    ) )}
                </div>

                { showChild && 
                    <div className='childs' style={{ top: `${showChild.y}px`, left: `${showChild.x}px` }} >
                       {hasDecisions(currentDecision) && 
                            <div className='parent-label'>
                                <span>{text}</span>
                            </div>
                        }
                        {hasDecisions(currentDecision) && currentDecision.decisions.map((item, index) => {
                            
                            const isDecision = hasDecisions(item);
                            const isSelected = (decisionIndex===index && itemSelected)
                            const text =  (item.name || item.answers) ? item.name : item.answer

                            return ( 
                                <CircledOption 
                                    key={index}
                                    text={text} 
                                    className='wide'
                                    data={item} 
                                    dots={!!isDecision && item.decisions.length > 0} 
                                    className={`right wide ${item.choosed ? 'done' : '' } ${!isSelected ? 'not-selected' : 'selected'}`}
                                    currentIndex={index}
                                    itemSelected={isSelected}
                                    onClickHandle={(e) => handleChildSelection(e, index, currentIndex, isDecision)}
                                    answerCallback={answerCallback}
                                />
                            )
                        })}
                    </div>
                }
                
            </div>
    )


}

export default CircledOption;